import CloseIcon from "@mui/icons-material/Close";
import { FilterDuotoneIcon } from "../../../components/svg";

export default function MapFilterMenu({ open, setOpen }) {
  return (
    <>
      {!open ? (
        <span
          className={`flex items-center justify-center px-1 mt-1`}
          onClick={() => setOpen(true)}
        >
          <FilterDuotoneIcon />
        </span>
      ) : (
        <span
          className={`flex items-center justify-center px-1 mt-1`}
          onClick={() => setOpen(false)}
        >
          <CloseIcon sx={{ width: "25", height: "25", color: "#046172ff" }} />
        </span>
      )}
    </>
  );
}
